import { AppModuleNext } from '@amarkets/atlas/esm/lib/app-module-next';

const rootComponent = () => import(
  './components/module-root/module-root.vue'
);

export default {
  module: new AppModuleNext(rootComponent),
};
